var map = {
	"./medal_level0.png": 297,
	"./medal_level1.png": 298,
	"./medal_level10.png": 307,
	"./medal_level11.png": 308,
	"./medal_level2.png": 299,
	"./medal_level3.png": 300,
	"./medal_level4.png": 301,
	"./medal_level5.png": 302,
	"./medal_level6.png": 303,
	"./medal_level7.png": 304,
	"./medal_level8.png": 305,
	"./medal_level9.png": 306
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 747;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/levels ^\.\/medal_level.*\.png$
// module id = 747
// module chunks = 0